<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
     <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousVendorView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Container / Vehicle Gate-Out Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
        <!-- <md-layout md-gutter v-if="gateOut.gateOutId!=''">
          <md-layout md-flex="70"></md-layout>
          <md-layout md-flex="30">
            <h4
              class="showMoreData"
              @click="showMoreContainer"
            >Click here to {{showMoreNew==true?"Hide":"Show"}} More Details</h4>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout> -->
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label for="gateInType">Gate-Out Type</label>
              <model-list-select
                option-value="gateTypeListV"
                option-text="gateTypeListT"
                :list="gateTypeList"
                placeholder="Select Type"
                v-model="gateOut.gateOutType"
                :isDisabled="gateOut.gateOutId!=''?true:false"
              ></model-list-select>
            </md-layout>

            <span class="error" v-if="!gateOut.gateOutType">{{gateOutTypeError}}</span>
          </md-layout>
        </md-layout>
        <div>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="35" v-if="gateOut.gateOutType=='Vehicle_With_Container'">
              <label for="bookOrgateOut">Booking / Gate-Out</label>
              <model-list-select
                :list="bookOrgateOutList"
                option-value="bookOrgateOutValue"
                option-text="bookOrgateOutText"
                placeholder="Select Booking/Gate-Out"
                name="bookOrgateOut"
                id="bookOrgateOut"
                v-model="gateOut.bookOrgateOut"
              ></model-list-select>
              <span class="error" v-if="!gateOut.bookOrgateOut">{{bookGateOutError}}</span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout
              md-flex="5"
              v-if="gateOut.gateOutType=='Vehicle_With_Container' && gateOut.editContainerNo=='' "
            ></md-layout>

            <md-layout
              md-flex="35"
              v-if="gateOut.gateOutType=='Vehicle_With_Container' && gateOut.editContainerNo=='' "
            >
              <label for="containerNo">Gate-Out Container No.</label>
              <model-list-select
           :isDisabled="new Date().toISOString().split('T')[0]!=new Date(gateOut.dispatchDate).toISOString().split('T')[0]?true:false"
                option-value="containerGateInId"
                option-text="containerNo"
                :list="containerList"
                placeholder="Select Container"
                v-model="gateOut.containerNo"
              ></model-list-select>

              <span class="error" v-if="!gateOut.containerNo">{{containerNoError}}</span>
            </md-layout>
            <md-layout
              md-flex="5"
              v-if="gateOut.gateOutType=='Vehicle_With_Container'  &&   ContainerDetail.containerGateInId!='' "
            ></md-layout>
            <md-layout
              md-flex="25"
              v-if="gateOut.gateOutType=='Vehicle_With_Container'  &&   ContainerDetail.containerGateInId!='' "
            >
              <label for="containerNo">Gate-Out Container No.</label>

              <b-form-input :formatter="capitalizeAll"
                id="containerNo"
                name="containerNo"
                v-model="gateOut.editContainerNo"
                disabled
              ></b-form-input>
              <!-- <b-fo
              disabled
              option-value="containerGateInId"
              option-text="containerNo"
              :list="containerList"
              placeholder="Select Container"
              v-model="gateOut.containerNo"
            ></model-list-select>

              <span class="error" v-if="!gateOut.containerNo">{{containerNoError}}</span>-->
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <md-layout md-flex="100" v-if="gateOut.gateOutType=='Vehicle_With_Container' ">
                <label for="containerSeal1">Container Seal No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="containerSeal1"
                  name="containerSeal1"
                  v-model="ContainerDetail.containerSeal"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <div v-if="gateOut.containerNo!='' || ContainerDetail.containerGateInId!=''">
            <hr class="hr-s" />
            <md-layout md-gutter v-if="gateOut.gateOutType=='Vehicle_With_Container'">
              <md-layout md-flex="5"></md-layout>
              <label>
                <b>
                  <u>Container Details(Gate-In)</u>
                </b>
              </label>
              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout md-gutter v-if="gateOut.gateOutType=='Vehicle_With_Container'">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Container Size / Type</label>

                  <b-form-input :formatter="capitalizeAll"
                    id="containerTypeId"
                    name="containerTypeId"
                    v-model="ContainerDetail.containerTypeId"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>Gross Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="grossWeight"
                    name="grossWeight"
                    v-model="ContainerDetail.grossWeight"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>Tare Wgt.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="tareWeight"
                    name="tareWeight"
                    v-model="ContainerDetail.tareWeight"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>Mfg. Mnth-Yr</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="manufractureYear"
                    name="manufractureYear"
                    v-model="ContainerDetail.manufractureYear"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Gate-In Vehicle No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="vehicleNo"
                    name="vehicleNo"
                    v-model="ContainerDetail.vehicleNo"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <hr class="hr-s" />
          </div>

          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout
              md-flex="35"
              v-if="gateOut.gateOutType!='' && hideGateOutV!='1'  && (gateOut.bookOrgateOut=='1' ||  gateOut.gateOutType=='Empty_Vehicle') "
            >
              <label for="gateOutVehicle">Gate-Out Vehicle No.</label>
              <model-list-select
              @input="getVehicle"
                option-value="vehicleNo"
                option-text="vehicleNo"
                :list="vehicleMasterList"
                placeholder="Select Vehicle"
                v-model="ContainerDetail.gateOutVehicle"
              ></model-list-select>

              <span class="error" v-if="!ContainerDetail.gateOutVehicle">{{gateOutVehicleError}}</span>
            </md-layout>
            <md-layout
              md-flex="25"
              v-if="gateOut.gateOutType!='' && hideGateOutV=='1'  && (gateOut.bookOrgateOut=='1' ||  gateOut.gateOutType=='Empty_Vehicle') "
            >
              <label for="gateOutVehicle">Gate-Out Vehicle No.</label>
              <b-form-input :formatter="capitalizeAll"
                id="manufractureYear"
                name="manufractureYear"
                v-model="ContainerDetail.gateOutVehicle"
                disabled
              ></b-form-input>
              <!-- <model-list-select
                option-value="vehicleNo"
                option-text="vehicleNo"
                :list="vehicleMasterList"
                placeholder="Select Vehicle"
                v-model="ContainerDetail.gateOutVehicle"
              ></model-list-select>-->
              <span class="error" v-if="!ContainerDetail.gateOutVehicle">{{gateOutVehicleError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout
              md-flex="20"
              v-if="gateOut.gateOutType!=''   && (gateOut.bookOrgateOut=='1' ||  gateOut.gateOutType=='Empty_Vehicle') "
            >
              <md-layout md-flex="100">
                <label for="containerSeal">Transporter Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="gateOutTransporter"
                  name="gateOutTransporter"
                  v-model="ContainerDetail.gateOutTransporter"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout
                md-flex="100"
                v-if="gateOut.gateOutType=='Vehicle_With_Container' && gateOut.bookOrgateOut=='1'"
              >
                <label for="GateOutContainerCondition">Container Condition</label>
                <b-form-input :formatter="capitalizeAll"
                  id="destinationddgd"
                  name="GateOutContainerCondition"
                  v-model="ContainerDetail.GateOutContainerCondition"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!ContainerDetail.GateOutContainerCondition"
              >{{containerConditionError}}</span>
            </md-layout>
          </md-layout>
          <hr
            class="hr-border"
            v-if="gateOut.gateOutType!='' &&  (gateOut.bookOrgateOut=='1' ||  gateOut.gateOutType=='Empty_Vehicle') "
          />
        </div>
        <div v-if="showMoreNew==true || gateOut.gateOutId==''">
          <div v-if="gateOut.gateOutType=='Vehicle_With_Container'">
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Client Name</label>
                  <!-- For destination  -->
                  <b-form-input :formatter="capitalizeAll" id="destination" name="destination" v-model="gateOut.destination"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="importStatus">Transport Type</label>
                <model-list-select
                  option-value="ImpVal"
                  option-text="ImpText"
                  :list="ImpList"
                  placeholder="Select Type "
                  v-model="gateOut.importStatus"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Dispatch Date</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="dispatchDate"
                    name="dispatchDate"
                    v-model="gateOut.dispatchDate"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Do / Booking Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="doNumber"
                    name="doNumber"
                    @keyup="sameDoNumber"
                    v-model="gateOut.doNumber"
                  ></b-form-input>
                </md-layout>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Re-Enter Do / Booking Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="checkdoNumber"
                    name="checkdoNumber"
                    @keyup="sameDoNumber"
                    v-model="gateOut.checkdoNumber"
                  ></b-form-input>
                  <span class="error" v-if="gateOut.passNotMatchErr!=''">{{passNotMatchErr}}</span>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Booking Date</label>
                <date-picker :format="selectDateFormat" lang="en" v-model="gateOut.bookingDate" id="bookingDate"></date-picker>
                <!-- <span class="error" v-if="!gateOut.bookingDate">{{bookingDateError}}</span> -->
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45"></md-layout>
              <md-layout md-flex="15">
                <label>DO Issue Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  v-model="gateOut.doValidity"
                  @input="addDays"
                  id="doValidity"
                ></date-picker>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Validity Date {{validateDate}}</label>
                <date-picker :format="selectDateFormat" lang="en" v-model="gateOut.validityDate" id="validityDate" disabled></date-picker>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr" v-if="gateOut.uploadDo!=''">
            <md-layout md-flex="50"></md-layout>
            <ul v-if="viewDocument.length>0">
              <md-layout md-flex="15" v-for="(item,index) in viewDocument" :key="index">
                <a
                  :href="'http://13.229.240.246/doGateOut/'+item"
                  target="_blank"
                  download
                >View Document - {{index+1}}</a>
              </md-layout>
            </ul>
            </md-layout>-->
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <md-input-container>
                  <label>Upload DO / Booking Order</label>
                  <md-file
                    name="uploadDriverDoc"
                    id="uploadDriverDoc"
                    v-model="gateOut.uploadDo"
                    @selected="onFileChange"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="50">
                <md-input-container>
                  <label>Upload Images</label>
                  <md-file
                    name="uploadImg"
                    id="uploadImg"
                    v-model="gateOut.uploadImg"
                    @selected="onFileChangeImg"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout>
            </md-layout>
          </div>
          <md-layout md-gutter class="gutr" v-if="gateOut.uploadImg!=''">
            <md-layout md-flex="5"></md-layout>
            <ul v-if="viewDocument.length>0">
              <md-layout md-flex="35" v-for="(item,index) in viewDocument" :key="index">
                <a
                  :href="`${this.docURL}/doGateOut/`+item"
                  target="_blank"
                  download
                >View Document - {{index+1}}</a>
              </md-layout>
            </ul>
            <md-layout md-flex="30"></md-layout>
            <ul v-if="viewImgDocument.length>0">
              <md-layout md-flex="35" v-for="(item,index) in viewImgDocument" :key="index">
                <a
                  :href="`${this.docURL}/doGateOutImg/`+item"
                  target="_blank"
                  download
                >View Document - {{index+1}}</a>
              </md-layout>
            </ul>
          </md-layout>

          <hr class="hr-border" v-if="gateOut.gateOutType=='Vehicle_With_Container'" />
        </div>
        <md-layout md-gutter class="gutr">
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="15" style="margin-top:1%">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              id="addButtonLoadergate"
              v-if="gateOut.gateOutType!='' && ContainerDetail.containerGateInId!=''"
              @click="addContainer"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loadergate" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
        <!-- <hr class="hr-border" v-if="gateOut.gateOutType!=''">

        <md-layout md-gutter class="mrgtop-button" v-if="allContainerDetail.length>0">
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoader"
              @click="addGateOutDetail"
            >{{editVar.Inputval}}</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>-->
        <div
          class="box"
          v-if="allContainerDetail.length>0 && gateOut.gateOutType=='Vehicle_With_Container'"
        >
          <hr class="hr-s" />
          <div class="box-header">
            <h5 class="box-title">Gate-Out Container Details </h5>
          </div>

          <!-- /.box-header -->
          <div class="box-body">
            <table id="vehicleWith" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Container No.</th>
                  <th>Container Status</th>
                  <th>Container Seal No.</th>
                  <th>Gate-In Vehicle Number</th>
                  <th>Gate-Out Vehicle Number</th>
                  <th>Creation Date</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in allContainerDetail" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.containerNo }}</td>
                  <td>{{item.bookOrgateOut=="2"?'Booked':item.bookOrgateOut=="3"?'Validity Expired':'Gate-Out'}}</td>
                  <td>{{item.containerSeal }}</td>
                  <td>{{item.vehicleNo }}</td>
                  <td>{{item.gateOutVehicle==''?'--':item.gateOutVehicle }}</td>

                  <td>{{item.loginTime | moment}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="viewModalPage(item.containerGateInId)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <div class="box" v-if="allContainerDetail.length>0 && gateOut.gateOutType=='Empty_Vehicle'">
          <div class="box-header">
            <h3 class="box-title">Vehicle Details &nbsp;</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="emptyVehicle" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Gate-Out Vehicle Number</th>
                  <th>Creation Date</th>
                  <!-- <th>Delete</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in allContainerDetail" :key="index">
                  <td>{{index+1}}</td>

                  <td>{{item.vehicleNo }}</td>

                  <td>{{item.loginTime | moment}}</td>
                  <!-- <td > 
              <md-button   class="md-icon-button md-raised md-dense " @click="deleteData(item.containerGateInId)" >
  <md-icon>delete_sweep</md-icon>

                  </md-button></td>-->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
          </b-card-text>
        </b-card>
      </b-card-text>
     </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="ValidityNote"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop3"
      @close="onClose3"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <!-- <md-dialog-alert
  :md-content="alert.content"
  :md-ok-text="alert.ok"
  ref="addPop1" 
  @close="onClose1" >
    </md-dialog-alert>-->
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: true,
      ImpList: [
        {
          ImpVal: "Export",
          ImpText: "Export"
        },
        {
          ImpVal: "Empty_Moment",
          ImpText: "Empty Moment"
        }
      ],
      gateTypeList: [
        {
          gateTypeListV: "Vehicle_With_Container",
          gateTypeListT: "Vehicle With Container"
        },
        {
          gateTypeListV: "Empty_Vehicle",
          gateTypeListT: "Empty Vehicle"
        }
      ],
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editPOId") != "" &&
          this.$sessionsStorage.get("editPOId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      showMoreNew: true,
      savedGateOutVehicle:"",
      gateOut: {
        editContainerNo: "",
        bookOrgateOut: "",
        gateOutId: "",
        containerNo: "",
        destination: "",
        dispatchDate: "",
        containerGateInId: "",
        gateOutType: "",
        doNumber: "",
        checkdoNumber: "",
        uploadDo: "",
        importStatus: "Export",
        doValidity: "",
        bookingDate: "",
        validityDate: "",
        uploadImg: ""
      },
      deleteID: "",
      total: "",
      containerNoError: "",

      containerConditionError: "",
      dispatchDateError: "",
      container: [{}],
      vehicleDetail: [{}],
      hideGateOutV: "",
      ContainerDetail: {
        gateOutTransporter: "",
        ContainerDetail: "",
        containerSeal: "",
        containerGateInId: "",
        containerNo: "",
        containerTypeId: "",
        gateOutId: "",
        GateOutContainerCondition: "",
        gateOutType: "",
        gateOutVehicleId: "",

        tareWeight: "",
        manufractureYear: "",
        containerCondition: "",
        sealNo: "",
        remarks: "",
        grossWeight: "",
        gateInId: "",
        vehicleNo: "",
        gateOutVehicle: "",
        vehicleTruckId: "",
        gateInType: "",
        transportName: "",
        repairStatus: ""
      },
      passNotMatchErr: "",
      shippingDetailsNew: [],
      containerRepairDetails: [],
      gateInDetailsArry: [],
      remarkError: "",
      containerNoError: "",
      containerTypeIdError: "",
      shippingIdError: "",
      tareWeightError: "",
      manufractureYearError: "",
      containerConditionError: "",
      sealNoError: "",
      vehcleArrivalDateError: "",
      transportNameError: "",
      arrivalFromError: "",
      vehicleNoError: "",
      gateOutVehicleError: "",
      grossWeightError: "",
      containerGateInIdError: "",
      sameContainerError: "",
      gateOutTypeError: "",
      bookGateOutError: "",
      bookingDateError: "",

      maintain: {
        surveyDate: "",
        approvedDate: "",
        repairDate: "",
        gateInSeries: "",
        estimationAmount: "",
        approvalAmount: "",
        status: "",
        gateInId: "",
        itemMasterId: "",
        maintainenceId: "",
        dispatchDate: ""
      },
      surveyDateError: "",
      statusError: "",
      gateInSeriesError: "",
      approvedDateError: "",
      repairDateError: "",
      estimationAmountError: "",
      approvalAmountError: "",

      finalVehicleId: "",
      itemModal: {
        itemMaintainenceId: "",
        maintainenceId: "",
        itemId: "",
        itemNameCode: "",
        poOrderId: "",
        itemCode: "",
        itemName: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: ""
      },
      compareDate: new Date(),
      stockInDetails: {
        poOrderId: "",
        poItemId: "",
        maintenanceType: "",
        itemId: "",
        location: "",
        addedByPerson: "",
        department: "",
        poDate: "",
        uploadPoDoc: "",
        vendorName: "",
        specificPoDetail: ""
      },
      openCModal: false,
      validate: true,

      maintenanceTypeError: "",
      locationError: "",
      addedByPersonError: "",
      departmentError: "",
      poDateError: "",
      vendorNamError: "",
      employeeMaster: [
        {
          employeeName: "ajit"
        }
      ],

      bookOrgateOutList: [
        {
          bookOrgateOutValue: "1",
          bookOrgateOutText: "Gate-Out"
        },
        {
          bookOrgateOutValue: "2",
          bookOrgateOutText: "Booking"
        }
      ],

      vendorMaster: [],
      departmentMaster: [],

      itemDetail: [
        {
          itemCode: "ajit"
        }
      ],
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      itemArrayShow: [],
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      itemCodeError: "",
      allContainerDetail: [],

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editGateOutId") != "" &&
          this.$sessionsStorage.get("editGateOutId") != undefined
            ? "Update"
            : "Submit",
        FormVal:
          this.$sessionsStorage.get("editGateOutId") != "" &&
          this.$sessionsStorage.get("editGateOutId") != undefined
            ? "Update"
            : "New"
      }
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  watch: {
    ContainerDetail: {
      handler: function(newVal, oldVal) {
        if (this.gateOut.gateOutType != "") {
          this.clearError();
        }

        if (this.ContainerDetail.gateOutVehicle != "") {
          let item = this.vehicleMasterList.filter(x => {
            return x.vehicleNo == this.ContainerDetail.gateOutVehicle;
          });

          if (item.length > 0) {
            if (this.gateOut.gateOutType == "Empty_Vehicle") {
              this.ContainerDetail.containerGateInId =
                item[0].containerGateInId;
            }
            this.ContainerDetail.gateOutVehicleId = item[0].containerGateInId;
          }
        }
      },

      deep: true
    },
    gateOut: {
      handler: function(newVal, oldVal) {
        if (this.gateOut.gateOutType != "") {
          this.clearError();
        }

        if (this.gateOut.containerNo != "") {
          let arrayGateInC = this.container.filter(x => {
            return x.containerGateInId == this.gateOut.containerNo;
          });
          // this.showMoreNew = false;
          this.gateOut.containerGateInId = this.gateOut.containerNo;

          Object.keys(this.ContainerDetail).map(x => {
            console.log(x)
            if(x!='containerSeal' && x!='GateOutContainerCondition' && x!='gateOutTransporter' ){
          this.ContainerDetail[x] = arrayGateInC[0][x] || "";
            }
            
          });
        }
      },

      deep: true
    }
  },

  beforeDestroy() {
    this.$sessionsStorage.set("editGateOutId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    validateDate() {
      if (this.gateOut.doValidity != "") {
        var date = new Date();
        let newDate = date.setDate(date.getDate() - 1);

        return this.formatDate(this.gateOut.validityDate) >
          this.formatDate(newDate)
          ? true
          : false;
      } else {
        return false;
      }
    },
    viewDocument() {
      return this.gateOut.uploadDo.split(",");
    },
    viewImgDocument() {
      return this.gateOut.uploadImg.split(",");
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },

    itemMasterList() {
      return this.itemDetail;
    },

    employeeMasterList() {
      return this.employeeMaster;
    },
    containerList() {
      return this.container;
    }
  },
  methods: {
    getVehicle(){
      this.savedGateOutVehicle=this.ContainerDetail.gateOutVehicle

    },
    clearConModal() {
      Object.keys(this.ContainerDetail).map(x => {
        this.ContainerDetail[x] = "";
      });
    },
    showMoreContainer() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    viewModalPage(itemID) {
      let array = this.allContainerDetail.filter(x => {
        return x.containerGateInId == itemID;
      });
      console.log(array);

      this.gateOut.editContainerNo = array[0].containerNo;
      this.ContainerDetail.containerTypeId = array[0].containerTypeId;
      this.ContainerDetail.containerGateInId = array[0].containerGateInId;
      this.ContainerDetail.grossWeight = array[0].grossWeight;
      this.ContainerDetail.tareWeight = array[0].tareWeight;
      this.ContainerDetail.manufractureYear = array[0].manufractureYear;
      this.ContainerDetail.vehicleNo = array[0].vehicleNo;
      this.ContainerDetail.containerSeal = array[0].containerSeal;
      this.ContainerDetail.gateOutTransporter = array[0].gateOutTransporter;
      this.ContainerDetail.gateOutVehicle = array[0].gateOutVehicle;
      this.ContainerDetail.gateOutVehicleId = array[0].gateOutVehicleId;
      this.hideGateOutV = array[0].containerStatus;
      this.openCModal = true;
      // console.log(this.ContainerDetail.bookOrgateOut);

      // Object.keys(this.allContainerDetail).map(x => {
      //   this.ContainerDetail[x] = item[x] || "";
      // });

      // this.openItemDialog();
    },
    sameDoNumber(e) {
      if (this.gateOut.doNumber != this.gateOut.checkdoNumber) {
        this.passNotMatchErr = "Do-Number do not match";
      } else {
        this.passNotMatchErr = "";
      }
      if (e.ctrlKey) {
        this.gateOut.checkdoNumber = "";
      }
    },
    addDays() {
      let days = 2;
      let result = new Date(this.gateOut.doValidity);
      result.setDate(result.getDate() + days);
      this.gateOut.validityDate = result;
    },

    clearError() {
      this.containerNoError = "";
      this.gateOutVehicleError = "";
    },
    onFileChangeImg() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("gateOutImg[]", files[i]);
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/Api_Yard/uploadGateDo.php`, formData, config)
        .then(result => {
          this.gateOut.uploadImg = result.data;
        })
        .catch(err => {
          throw err;
        });
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("gateOufile[]", files[i]);
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/Api_Yard/uploadGateDo.php`, formData, config)
        .then(result => {
          this.gateOut.uploadDo = result.data;
        })
        .catch(err => {
          throw err;
        });
    },

    validateModal() {
      let validate_new = true;

      if (
        this.ContainerDetail.gateOutVehicle == "" &&
        this.gateOut.bookOrgateOut == "1"
      ) {
        $("#gateOutVehicle").focus();
        this.vehicleNoError = "Select Gate-Out Vehicle";
 console.log("2ee");
        validate_new = false;
      }
      // if (this.gateOut.bookingDate == "") {
      //   $("#bookingDate").focus();
      //   this.bookingDateError = "Select Booking Date";
      //   validate_new = false;
      // }
      if (this.gateOut.gateOutType == "") {
        $("#gateOutType").focus();
        this.gateOutTypeError = "Select Gate-Out Type";
        console.log("2");
        validate_new = false;
      }
      if (
        this.gateOut.bookOrgateOut == "" &&
        this.gateOut.gateOutType == "Vehicle_With_Container"
      ) {
        $("#bookOrgateOut").focus();
        this.bookGateOutError = "Select As Applicable";
 console.log("88");
        validate_new = false;
      }

      if (
        this.gateOut.gateOutType == "Vehicle_With_Container" &&
        this.gateOut.containerNo == "" &&
        this.gateOut.gateOutId == ""
      ) {
        $("#containerNo").focus();
        this.containerNoError = "Enter Container No";
 console.log("55");
        validate_new = false;
      }

      if (
        this.validateDate == false &&
        this.gateOut.gateOutType == "Vehicle_With_Container"
      ) {
        this.alert.content = "Validity Expired..!! You Cannot Proceed Further";
        this.$refs["ValidityNote"].open();
 console.log("1");
        validate_new = false;
      }

      if (
        this.gateOut.gateOutType == "Empty_Vehicle" &&
        this.ContainerDetail.gateOutVehicle == "" &&
        this.gateOut.containerGateInId == ""
      ) {
        $("#gateOutVehicle").focus();
        this.gateOutVehicleError = "Enter Gate-Out Vehicle No";
        console.log("4");
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addContainer() {
      if (this.gateOut.bookOrgateOut == "") {
        this.gateOut.bookOrgateOut = 0;
      }
      if (this.gateOut.gateOutId != "") {
        this.ContainerDetail["gateOutId"] = this.gateOut.gateOutId;
      } else {
        this.ContainerDetail["gateOutId"] = "";
      }
      if (this.gateOut.gateOutType == "Vehicle_With_Container") {
        if (this.gateOut.doNumber != this.gateOut.checkdoNumber) {
          this.passNotMatchErr = "Do-Number do not match";
          return false;
        } else {
          this.passNotMatchErr = "";
        }
      }
       this.ContainerDetail.gateOutVehicle=this.savedGateOutVehicle
      let newData = {
        gateOutModal: this.gateOut,
        containerModal: this.ContainerDetail
      };
   if (this.gateOut.gateOutType == "Empty_Vehicle") {
      this.gateOut.containerNo=''
   }

      // var date = new Date();
      // let newDate = date.setDate(date.getDate() + 1);

      // console.log(
      //   this.formatDate(newDate) >= this.formatDate(this.gateOut.validityDate),
      //   this.formatDate(newDate),
      //   this.formatDate(this.gateOut.validityDate)
      // );

      this.validateModal();

      if (this.validate != false) {
        $("#addButtonLoadergate").css("display", "none");
        $("#loadergate").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addGateOut.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.$sessionsStorage.set("editGateOutId", data.Id);
              $("#loadergate").css("display", "none");
              $("#addButtonLoadergate").css("display", "block");
              if (data.msg != "Updated Successfully") {
                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data updated Succesfully";
              }

              this.getData();

              // this.$refs["addPop"].open();
              Object.keys(this.ContainerDetail).map(x => {
                this.ContainerDetail[x] = "";
              });
            }
          })

          .catch(error => {});
      }
    },
    onClose(type) {},

    // JqueryFun() {
    //   return $(function() {
    //     $("#repairContainer").DataTable();
    //     $("#emptyVehicle").DataTable();
    //     $("#vehicleWith").DataTable();
    //   });
    // },

    deleteData(GateOutStatusId) {
      this.deleteID = GateOutStatusId;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
      }
    },
    onClose3(type) {
      this.$router.push({
        path: "/yard/viewGateOut"
      });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },

    getData() {
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        gateOutId: this.$sessionsStorage.get("editGateOutId")
      };

      let currentDate = new Date();
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/fetchToGateOut.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.gateinAllData.length) {
              this.gateInDetailsArry = data.gateinAllData;
              // this.gateOut.doValidity = data.gateinAllData[0].doValidity;
            }
            if (data.gateInContainer.length) {
              this.container = data.gateInContainer;
            }

            if (data.vehicleDetail.length) {
              this.vehicleDetail = data.vehicleDetail;
            }

            if (data.repairData.length > 0) {
              this.containerRepairDetails = data.repairData;
            } else {
              this.containerRepairDetails = [];
            }
            if (data.itemArray.length > 0) {
              this.allContainerDetail = data.itemArray;
              console.log(this.allContainerDetail);
            } else {
              this.allContainerDetail = [];
            }

            if (data.editGateOutDetails.length > 0) {
              Object.keys(this.gateOut).map(x => {
                this.gateOut[x] = data.editGateOutDetails[0][x] || "";
              });
            }

            if (
              this.$sessionsStorage.get("editGateOutId") == "" ||
              this.$sessionsStorage.get("editGateOutId") == null
            ) {
              this.gateOut.dispatchDate = this.formatDate(currentDate);
            } else {
              this.gateOut.checkdoNumber = this.gateOut.doNumber;
            }

            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    validateGateOut() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    // addGateOutDetail() {
    //   this.validateGateOut();
    //   this.gateOut["finalVehicleId"] = this.finalVehicleId;

    //   if (this.validate != false) {
    //     $("#addButtonLoader").css("display", "none");
    //     $("#loader").css("display", "block");

    //     let options = {
    //       method: "POST",
    //       url: `${URL_BASE}/Api_Yard/addGateOut.php`,
    //       data: JSON.stringify(this.gateOut),
    //       crossDomain: true,

    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //         Authorization: this.$sessionsStorage.get("loginId")
    //       }
    //     };

    //     axios(options)
    //       .then(result => {
    //         const { statusText, status, data } = result;

    //         if ( status == 200 && data) {
    //           // this.serviceDetails.itemForServiceEstId += ",";

    //           $("#loader").css("display", "none");
    //           $("#addButtonLoader").css("display", "block");
    //           this.$refs["addPop3"].open();
    //         }
    //       })
    //       .catch(error => {});
    //   }
    // },

    previousVendorView() {
      this.$router.push({
        path: "/yard/viewGateOut"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.marg-top {
  margin-top: 0%;
}
</style>


// WEBPACK FOOTER //
// gateOut.vue?30b0c2fc